import { useState } from 'react';
import './styles.css';
import Event, {EventType} from '../../objects/Event';
import CheckBox from '../../objects/Checkbox';

const events = [
	{
		log: 'Adicionou O',
		type: EventType.Mark
	},
	{
		log: 'Adicionou X',
		type: EventType.Mark
	},
	{
		log: 'Adicionou O',
		type: EventType.Mark
	},
	{
		log: 'Adicionou X',
		type: EventType.Mark
	},
	{
		log: 'Adicionou O',
		type: EventType.Mark
	},
	{
		log: 'Empate!',
		type: EventType.Draw
	},
	{
		log: 'Vitória!',
		type: EventType.Win
	}
]

type EventPanelProps = {

}; 

const EventPanel = ( props: EventPanelProps): JSX.Element => {
	const [show, setShow] = useState(true);
	
	const handleCheckboxState = () => {
		setShow(!show)
	}

	return (
		<div id='panel-wrapper'>
			<CheckBox 
				aria-controls='event-wrapper'
				aria-expanded={show}
				checked={show} 
				handleCheck={handleCheckboxState} 
				labelForChecked='Esconder eventos' 
				labelForNotChecked='Mostrar eventos'
				 />
			{show && 
				<div id='event-wrapper' 
					role='region' 
					aria-label='eventos' 
					style={{'overflowY': 'auto'}} 
					// eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
					tabIndex={0} 
				>
					<Event events={events} />
				</div>
			}
		</div>
	);
}

export default EventPanel;